module.exports = __webpack_public_path__ + "media/images/top/new-photowedding-b4ecd26498bb7f8c4e512c45392fa940.png";